module.exports = __webpack_public_path__ + "static/og-add39ef56ea073cdcd730beaf9bbff10.png";